import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
export const ReportActionsFloatingAlertStore = FloatingAlertStore.newFloatingAlertStore();